var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.2631 3.541L4.03042 1.30833C3.61932 0.897224 2.95273 0.897224 2.54163 1.30833L1.71942 2.13054C1.22344 2.62652 0.965442 3.30891 1.00373 4.00963C1.04617 4.76192 1.04866 5.4643 1.42565 6.38461C2.32859 8.59833 3.97789 10.4281 4.8177 11.2888C5.7123 12.156 7.4641 13.7004 9.61539 14.5743C10.5425 14.9513 11.2407 14.9538 11.9904 14.9963C12.6911 15.0346 13.3726 14.7766 13.8695 14.2806L14.6917 13.4584C15.1028 13.0473 15.1028 12.3807 14.6917 11.9696L12.459 9.7369C12.0479 9.3258 11.3813 9.3258 10.9702 9.7369L9.80263 10.9045C9.17184 10.6873 8.00842 10.1904 6.914 9.10027C5.81217 8.00345 5.31619 6.83181 5.099 6.20099L6.26657 5.03342C6.67768 4.62231 6.67768 3.95573 6.26657 3.54462L6.2631 3.541Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.6aab104eedc6a4626342033c3755b5b9.svg";
export { ForwardRef as ReactComponent };